import type { PlaceHolderProps } from './types'

export const PLACEHOLDER: PlaceHolderProps = {
  FULL_NAME: 'First and Last Name',
  EMAIL: 'hello@email.com',
  PHONE: '(000) 000-0000',
}
